export default __webpack_public_path__ + "static/media/not-required-image.17cbcf36.png";